import {
    ReservationCreateForm,
    ReservationData,
    ReservationDataWithAssociatedServices,
    ReservationDeletionForm,
    ReservationHistoryData,
    ReservationListCreateForm,
    ReservationListQuery,
    ReservationUpdateForm,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/reservation';

export class ReservationApi {
    public static async getReservation(id: string): Promise<ReservationData> {
        const res = await axios.get(`${BASE_URL}/${id}`);

        return res.data.reservation;
    }

    public static async getReservationHistory(id: string): Promise<ReservationHistoryData[]> {
        const res = await axios.get(`${BASE_URL}/${id}/history`);

        return res.data.reservationHistory;
    }

    public static async find(
        params: ReservationListQuery & { withAssociatedServiceIds: true },
    ): Promise<ReservationDataWithAssociatedServices[]>;
    public static async find(params: ReservationListQuery): Promise<ReservationData[]>;
    public static async find(params: ReservationListQuery): Promise<ReservationData[]> {
        const res = await axios.get(BASE_URL, { params });

        return res.data.reservations;
    }

    public static async createList(reservations: ReservationCreateForm[], scheduleIds: string[]): Promise<void> {
        const form: ReservationListCreateForm = { reservations };

        await axios.post(`${BASE_URL}/list`, form, { params: { scheduleIds: scheduleIds.join('|') } });
    }

    public static async unbindReferral(referralId: string): Promise<void> {
        await axios.delete(`${BASE_URL}/referral/${referralId}`);
    }

    public static async removeReservation(id: string, form?: ReservationDeletionForm): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}`, { data: form });
    }

    public static async update(id: string, reservation: ReservationUpdateForm, scheduleIds: string[]): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, reservation, { params: { scheduleIds: scheduleIds.join(',') } });
    }

    public static async updatePatientCame(id: string, patientCame: boolean): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/patient-came`, { patientCame });
    }

    public static async updateStatus(id: string, status: string): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { status });
    }
}
